import {
  MonacoLanguageType,
  filePathExtension,
  filePathStem,
  guardNever,
} from "@hex/common";

import { ContextWorkbenchEntity } from "../contextWorkbenchEntity";
import { ContextWorkbenchFile } from "../contextWorkbenchFile";

import { getEntityRefForEntity } from "./entityRef";
import { getFileIdForEntityRef } from "./fileId";

export function getFileForEntity(
  entity: ContextWorkbenchEntity,
): ContextWorkbenchFile.Entity {
  if (entity.type === ContextWorkbenchEntity.Type.MagicRulesFile) {
    return getFileForMagicRulesEntity(entity);
  } else if (entity.type === ContextWorkbenchEntity.Type.OrgGuideFile) {
    return getFileForOrgGuideFileEntity(entity);
  } else {
    guardNever(entity, entity);
    return null as any;
  }
}

function getFileForMagicRulesEntity(
  entity: ContextWorkbenchEntity.MagicRulesFile,
): ContextWorkbenchFile.Entity {
  const entityRef = getEntityRefForEntity(entity);
  const id = getFileIdForEntityRef(entityRef);
  const filepath = entity.filename;
  const stem = filePathStem(filepath);
  const extension = filePathExtension(filepath);
  const language = getFileLanguage(extension);
  const contents = entity.fileContent;
  const sizeBytes = getFileSizeBytes(contents);
  return {
    id,
    type: ContextWorkbenchFile.Type.Entity,
    entityRef,
    contents,
    filepath,
    stem,
    extension,
    language,
    sizeBytes,
    readOnly: true,
  };
}

function getFileForOrgGuideFileEntity(
  entity: ContextWorkbenchEntity.OrgGuideFile,
): ContextWorkbenchFile.Entity {
  const entityRef = getEntityRefForEntity(entity);
  const id = getFileIdForEntityRef(entityRef);
  const filepath = entity.filePath;
  const stem = filePathStem(filepath);
  const extension = filePathExtension(filepath);
  const language = getFileLanguage(extension);
  const contents = entity.contents;
  const sizeBytes = getFileSizeBytes(contents);
  return {
    id,
    type: ContextWorkbenchFile.Type.Entity,
    entityRef,
    contents,
    filepath,
    stem,
    extension,
    language,
    sizeBytes,
    readOnly: false,
  };
}

function getFileSizeBytes(contents: string | null): number {
  if (contents == null) return 0;
  return new TextEncoder().encode(contents).length;
}

function getFileLanguage(extension: string): MonacoLanguageType {
  switch (extension) {
    case "sql":
      return "sql";
    case "json":
      return "json";
    case "md":
      return "markdown";
    case "txt":
    default:
      return "plaintext";
  }
}
